// extracted by mini-css-extract-plugin
export default {"tags":"Tags-module__tags__2WMuA","tag":"Tags-module__tag__1yXXo","label":"Tags-module__label__1yKmh","close":"Tags-module__close__oMB4g","icon":"Tags-module__icon__2y9nB"};